import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {AppSettings} from '../../app-settings';
import {tap} from 'rxjs/operators';
import * as moment from 'moment';
import {RoundNameConstants} from '../round-name-constants';
import Swal from 'sweetalert2';
import {AuthenticationService} from './authentication.service';

@Injectable({
    providedIn: 'root'
})
export class EpasUtilService {
    currentTime;
    term;


    data = {'status': 'fail'};
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            // 'x-access-token': this.authenticationService.getToken()
        })
    };

    constructor(private http: HttpClient,
                private authenticationService: AuthenticationService) {
    }

    getNextActiveRoundRouterLink(): string {
        if (this.term !== undefined && this.term !== null && this.term !== '') {
            if (this.term.rounds !== undefined && this.term.rounds !== null && this.term.rounds !== '') {
                this.currentTime = moment(this.term.current_time).utcOffset('+05:30');
				if (this.term.rounds.hasOwnProperty(RoundNameConstants.PRACTICE_BIDDING_ROUND) &&
                    ((this.currentTime >= moment(this.term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND].start_time).utcOffset('+05:30')
                        && this.currentTime < moment(this.term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND].end_time).utcOffset('+05:30')) ||
                        this.currentTime < moment(this.term.rounds[RoundNameConstants.PRACTICE_BIDDING_ROUND].start_time).utcOffset('+05:30'))) {
                    return '/bidding-rounds/practice-round#Bidding Practice Round';
                } else if (this.term.rounds.hasOwnProperty(RoundNameConstants.PRACTICE_CONFIRMATION_ROUND) &&
                    ((this.currentTime >= moment(this.term.rounds[RoundNameConstants.PRACTICE_CONFIRMATION_ROUND].start_time).utcOffset('+05:30')
                        && this.currentTime < moment(this.term.rounds[RoundNameConstants.PRACTICE_CONFIRMATION_ROUND].end_time).utcOffset('+05:30')) ||
                        this.currentTime < moment(this.term.rounds[RoundNameConstants.PRACTICE_CONFIRMATION_ROUND].start_time).utcOffset('+05:30'))) {
                    return '/confirmation/practice-round#Confirmation Practice Round';
                } else if (this.term.rounds.hasOwnProperty(RoundNameConstants.BIDDING_ROUND_ONE) &&
                    ((this.currentTime >= moment(this.term.rounds[RoundNameConstants.BIDDING_ROUND_ONE].start_time).utcOffset('+05:30')
                        && this.currentTime < moment(this.term.rounds[RoundNameConstants.BIDDING_ROUND_ONE].end_time).utcOffset('+05:30')) ||
                        this.currentTime < moment(this.term.rounds[RoundNameConstants.BIDDING_ROUND_ONE].start_time).utcOffset('+05:30'))) {
                    return '/bidding-rounds/round-1#Bidding Round I';
                } else if (this.term.rounds.hasOwnProperty(RoundNameConstants.CONFIRMATION_ROUND1) &&
                    ((this.currentTime >= moment(this.term.rounds[RoundNameConstants.CONFIRMATION_ROUND1].start_time).utcOffset('+05:30')
                        && this.currentTime < moment(this.term.rounds[RoundNameConstants.CONFIRMATION_ROUND1].end_time).utcOffset('+05:30')) ||
                        this.currentTime < moment(this.term.rounds[RoundNameConstants.CONFIRMATION_ROUND1].start_time).utcOffset('+05:30'))) {
                    return '/confirmation/round-1#Confirmation Round I';
                } else if (this.term.rounds.hasOwnProperty(RoundNameConstants.BIDDING_ROUND_TWO) &&
                    ((this.currentTime >= moment(this.term.rounds[RoundNameConstants.BIDDING_ROUND_TWO].start_time).utcOffset('+05:30')
                        && this.currentTime < moment(this.term.rounds[RoundNameConstants.BIDDING_ROUND_TWO].end_time).utcOffset('+05:30')) ||
                        this.currentTime < moment(this.term.rounds[RoundNameConstants.BIDDING_ROUND_TWO].start_time).utcOffset('+05:30'))) {
                    return '/bidding-rounds/round-2#Bidding Round II';
                } else if (this.term.rounds.hasOwnProperty(RoundNameConstants.CONFIRMATION_ROUND2) &&
                    ((this.currentTime >= moment(this.term.rounds[RoundNameConstants.CONFIRMATION_ROUND2].start_time).utcOffset('+05:30')
                        && this.currentTime < moment(this.term.rounds[RoundNameConstants.CONFIRMATION_ROUND2].end_time).utcOffset('+05:30')) ||
                        this.currentTime < moment(this.term.rounds[RoundNameConstants.CONFIRMATION_ROUND2].start_time).utcOffset('+05:30'))) {
                    return '/confirmation/round-2#Confirmation Round II';
                } else if (this.term.rounds.hasOwnProperty(RoundNameConstants.BIDDING_ROUND_THREE) &&
                    ((this.currentTime >= moment(this.term.rounds[RoundNameConstants.BIDDING_ROUND_THREE].start_time).utcOffset('+05:30')
                        && this.currentTime < moment(this.term.rounds[RoundNameConstants.BIDDING_ROUND_THREE].end_time).utcOffset('+05:30')) ||
                        this.currentTime < moment(this.term.rounds[RoundNameConstants.BIDDING_ROUND_THREE].start_time).utcOffset('+05:30'))) {
                    return '/bidding-rounds/round-3#Bidding Round III';
                } else if (this.term.rounds.hasOwnProperty(RoundNameConstants.CONFIRMATION_ROUND3) &&
                    ((this.currentTime >= moment(this.term.rounds[RoundNameConstants.CONFIRMATION_ROUND3].start_time).utcOffset('+05:30')
                        && this.currentTime < moment(this.term.rounds[RoundNameConstants.CONFIRMATION_ROUND3].end_time).utcOffset('+05:30')) ||
                        this.currentTime < moment(this.term.rounds[RoundNameConstants.CONFIRMATION_ROUND3].start_time).utcOffset('+05:30'))) {
                    return '/confirmation/round-3#Confirmation Round III';
                } else if (this.term.rounds.hasOwnProperty(RoundNameConstants.BIDDING_ROUND_FOUR) &&
                    ((this.currentTime >= moment(this.term.rounds[RoundNameConstants.BIDDING_ROUND_FOUR].start_time).utcOffset('+05:30')
                        && this.currentTime < moment(this.term.rounds[RoundNameConstants.BIDDING_ROUND_FOUR].end_time).utcOffset('+05:30')) ||
                        this.currentTime < moment(this.term.rounds[RoundNameConstants.BIDDING_ROUND_FOUR].start_time).utcOffset('+05:30'))) {
                    return '/bidding-rounds/round-4#Bidding Round IV';
                } else if (this.term.rounds.hasOwnProperty(RoundNameConstants.CONFIRMATION_ROUND4) &&
                    ((this.currentTime >= moment(this.term.rounds[RoundNameConstants.CONFIRMATION_ROUND4].start_time).utcOffset('+05:30')
                        && this.currentTime < moment(this.term.rounds[RoundNameConstants.CONFIRMATION_ROUND4].end_time).utcOffset('+05:30')) ||
                        this.currentTime < moment(this.term.rounds[RoundNameConstants.CONFIRMATION_ROUND4].start_time).utcOffset('+05:30'))) {
                    return '/confirmation/round-4#Confirmation Round IV';
				} else if (this.term.hasOwnProperty('registration_start_time') &&
					((this.currentTime >= moment(this.term.registration_start_time).utcOffset('+05:30') &&
						this.currentTime < moment(this.term.registration_end_time).utcOffset('+05:30')) ||
						this.currentTime < moment(this.term.registration_start_time).utcOffset('+05:30'))) {
					return '/application#Registration';
				} else {
                    return '#';
                }
            }
        }
    }

    getRefTime(id) {
        return (id + 9) / 7;
    }

    refreshTerm(studentId): Observable<any> {
        return this.http.get(AppSettings.JAVA_API + AppSettings.GET_TERM_AND_ROUND_DETAILS + studentId, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.authenticationService.getToken()
            })
        })
            .pipe(
                tap(
                    data => {
                        if (data.hasOwnProperty('token') && data.token === false) {
                            Swal({
                                type: 'warning',
                                title: 'Token expired',
                                text: 'Session is expired please login again.'
                            });
                            this.authenticationService.logout();
                        }
                    },
                    error => this.handleError(error)
                )
            );
    }

    private handleError = function (error: any) {
        console.error('An error occurred', error); //  for demo purposes only
        return throwError(
            error ||
            'Something bad happened; please contact support team.');
    };
}
